import React, { Component } from "react";
import axios from "axios";
import Conf from "./Conf";
import Navbar from "./components/Navbar";
import { goLogin, getPermission } from "./js/main";
import ReceiptIcon from "@material-ui/icons/Receipt";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import TableRow from "@material-ui/core/TableRow";
import BillPreview from "./components/BillPreview";

const page_title = "Replace Bill";
export default class NewBill extends Component {
  state = {
    on_process: true,
  };
  componentDidMount() {
    this.getAuth();
  }
  async getAuth() {
    var bill_id = this.props.match.params.id;
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    if (cookie && cookie.token) {
      var auth = await getPermission(cookie.token);
      if (auth === false) goLogin(Conf.frontendURL + "newbill/" + bill_id);
      else {
        var bill = await this.getBill();
        if (
          bill &&
          bill.canceled &&
          bill.canceled.status === true &&
          !bill.new_bill
        ) {
          var otp = await this.getOTP();
          this.setState(
            { profile: auth.profile, cookie, bill: bill, otp },
            () => this.setForm()
          );
        }
      }
    } else goLogin(Conf.frontendURL + "newbill/" + bill_id);
  }

  getOTP() {
    return new Promise((resolve) => {
      var bill_id = this.props.match.params.id;
      var cookie = localStorage.getItem(Conf.cookieName);
      cookie = JSON.parse(cookie);
      axios
        .post(
          Conf.digitalpayBackend + "otp",
          { type: "bill_preview", payload: { bill_id: bill_id } },
          {
            headers: { Authorization: cookie.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        });
    });
  }
  setForm() {
    var { bill } = this.state;
    var form = {
      replace_id: bill._id,
      invoice_id: bill.invoice_id.invoice_id,
      payer_name: bill.payer.name,
      idx: bill.payer.idx,
      email: bill.payer.email,
      addr: bill.payer.addr,
      amount: bill.amount,
    };
    this.setState({ form, on_process: false });
  }
  getBill() {
    return new Promise((resolve) => {
      var bill_id = this.props.match.params.id;
      var cookie = localStorage.getItem(Conf.cookieName);
      cookie = JSON.parse(cookie);
      axios
        .get(Conf.digitalpayBackend + "bill/" + bill_id, {
          headers: { Authorization: cookie.token },
        })
        .then(async (res) => {
          console.log(res.data);
          resolve(res.data);
        });
    });
  }
  changeForm(e) {
    var id = e.target.id;
    var { form } = this.state;
    form[id] = e.target.value;
    this.setState({ form });
  }
  save() {
    var { form, cookie } = this.state;
    this.setState({ on_process: true });
    axios
      .put(Conf.digitalpayBackend + "bill/replace", form, {
        headers: { Authorization: cookie.token },
      })
      .then((res) => {
        if (res.data.error) {
          alert(res.data.error);

          this.setState({ on_process: false });
        } else {
          alert("Save Completed");
          this.props.history.push(process.env.PUBLIC_URL + "/report");
        }
      });
  }
  updateForm(e) {
    var { form } = this.state;
    var id = e.target.id;
    form[id] = e.target.value;
    this.setState({ form });
  }
  render() {
    const { profile, form, on_process, otp } = this.state;
    const styles = {
      labelInput: {
        width: "150px",
        textAlign: "right",
        paddingRight: "20px",
        fontSize: "1.1rem",
        borderBottom: "none",
      },
      textInput: {
        padding: "5px 5px",
        borderBottom: "none",
      },
    };
    return (
      <>
        {profile && form && (
          <div>
            <Navbar />
            <main className="content">
              <h1 className="pageTitle">
                <div
                  style={{
                    float: "left",
                    paddingTop: "5px",
                    marginRight: "15px",
                  }}
                >
                  <ReceiptIcon style={{ fontSize: "2rem" }} />
                </div>
                <div style={{ float: "none" }}>{page_title}</div>
              </h1>

              <Grid container spacing={2}>
                <Grid item xs={12} lg={6}>
                  {otp && <BillPreview otp={otp} />}
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          component="th"
                          style={styles.labelInput}
                          scope="row"
                        >
                          Invoice No
                        </TableCell>
                        <TableCell style={styles.textInput}>
                          <TextField
                            id="invoice_id"
                            variant="outlined"
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                            value={form.invoice_id}
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          component="th"
                          style={styles.labelInput}
                          scope="row"
                        >
                          ชื่อผู้ชำระเงิน
                        </TableCell>
                        <TableCell style={styles.textInput}>
                          <TextField
                            id="payer_name"
                            variant="outlined"
                            fullWidth
                            value={form.payer_name}
                            onChange={(e) => this.updateForm(e)}
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          component="th"
                          style={styles.labelInput}
                          scope="row"
                        >
                          Tax ID
                        </TableCell>
                        <TableCell style={styles.textInput}>
                          <TextField
                            id="idx"
                            variant="outlined"
                            fullWidth
                            value={form.idx}
                            onChange={(e) => this.updateForm(e)}
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          component="th"
                          style={styles.labelInput}
                          scope="row"
                        >
                          email
                        </TableCell>
                        <TableCell style={styles.textInput}>
                          <TextField
                            id="email"
                            variant="outlined"
                            fullWidth
                            value={form.email}
                            onChange={(e) => this.updateForm(e)}
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          component="th"
                          style={styles.labelInput}
                          scope="row"
                        >
                          ที่อยู่
                        </TableCell>
                        <TableCell style={styles.textInput}>
                          <TextField
                            id="addr"
                            variant="outlined"
                            fullWidth
                            value={form.addr}
                            onChange={(e) => this.updateForm(e)}
                          />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          component="th"
                          style={styles.labelInput}
                          scope="row"
                        >
                          จำนวนเงิน
                        </TableCell>
                        <TableCell style={styles.textInput}>
                          <TextField
                            id="amount"
                            variant="outlined"
                            fullWidth
                            type="number"
                            value={form.amount}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <div style={{ textAlign: "center", marginTop: "30px" }}>
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      style={{ marginRight: "10px", width: "120px" }}
                      onClick={() => this.save()}
                      disabled={on_process}
                    >
                      ยืนยัน
                    </Button>
                    <Button
                      variant="contained"
                      size="large"
                      color="secondary"
                      style={{ width: "120px" }}
                      onClick={() =>
                        this.props.history.push(process.env.PUBLIC_URL + "/")
                      }
                      disabled={on_process}
                    >
                      ยกเลิก
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </main>
          </div>
        )}
      </>
    );
  }
}
